// Per-language display name override (NL / EN) shown in the phone-menu guide;
// the Teams name stays the canonical label.

import type { LocalizedName } from '../../api/client';
import { inputCls, labelCls } from './common';

export function LocalizedNameInput({ value, onChange, label = 'Name in the guide' }: {
  value?: LocalizedName;
  onChange: (v: LocalizedName | undefined) => void;
  label?: string;
}) {
  const set = (lang: 'nl' | 'en', text: string) => {
    const next: LocalizedName = { ...(value || {}) };
    if (text.trim()) next[lang] = text; else delete next[lang];
    onChange(Object.keys(next).length ? next : undefined);
  };
  return (
    <div>
      <label className={labelCls}>{label} <span className="font-normal text-gray-400">(optional, per language)</span></label>
      <div className="grid grid-cols-2 gap-2">
        <div className="flex items-center gap-1.5">
          <span className="text-[10px] font-semibold text-gray-500 w-5">NL</span>
          <input type="text" value={value?.nl || ''} onChange={e => set('nl', e.target.value)} placeholder="Klantenservice" className={inputCls} />
        </div>
        <div className="flex items-center gap-1.5">
          <span className="text-[10px] font-semibold text-gray-500 w-5">EN</span>
          <input type="text" value={value?.en || ''} onChange={e => set('en', e.target.value)} placeholder="Customer service" className={inputCls} />
        </div>
      </div>
    </div>
  );
}
